import { APIS } from '../constants/apis';
import { fetchAPI } from '../utils/fetchAPI';

export const savePost = async ({ jwt, data }) => {
  try {
    await fetchAPI({
      url: APIS.savePost,
      method: 'POST',
      header: {
        Authorization: `Bearer ${jwt}`,
      },
      data,
    });
  } catch (err) {
    throw new Error(err.message);
  }
};
